export default __webpack_public_path__ + "static/media/bike.ccbbaa06.png";